import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { buildPBComponents } from '@blaze-cms/plugin-page-builder-fe';
import { MainContextProvider } from '@blaze-cms/nextjs-components';
import { DRAFT_PREVIEW_MODE } from '../constants';

// Renders a draft page builder template or saved component preview: just the
// resolved component tree with a draft banner. Draft previews must never be
// indexed.
const PageBuilderPreviewContainer = ({ components, sourceName, itemId, itemEntity }) => (
  <MainContextProvider value={{ isPreview: true, itemId, itemEntity }}>
    <Head>
      <title>{`Draft preview: ${sourceName}`}</title>
      <meta name="robots" content="noindex,nofollow" />
    </Head>
    <div className="preview-header">{`${DRAFT_PREVIEW_MODE}: ${sourceName}`}</div>
    {!!components.length && buildPBComponents(components, {}, true)}
  </MainContextProvider>
);

PageBuilderPreviewContainer.propTypes = {
  components: PropTypes.array,
  sourceName: PropTypes.string,
  itemId: PropTypes.string.isRequired,
  itemEntity: PropTypes.string.isRequired
};

PageBuilderPreviewContainer.defaultProps = {
  components: [],
  sourceName: ''
};

export default PageBuilderPreviewContainer;
